<div class="modal-content" role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
  <div class="d-flex text-black modal-header pl-4 pr-4 mt-2">
    <h5 id="confirm-modal-title" class="font-18 mt-1">Please Confirm Your Registration Details</h5>
    <button type="button" class=" btn p-0 ml-5" aria-label="Close" (click)="modalClose()">
      <span class="material-symbols-outlined">
        close
      </span>
    </button>
  </div>
  <p class="para-1 sub-heading">Check the information below. If something doesn’t look right, please edit your details
    before
    proceeding.</p>
  <div class="modal-body">
    <div class="mb-3">
      <div class="d-flex mb-2">
        <p class="mb-0 para-1 col align-content-end pl-0">First Name</p>
        <p class="mb-0  align-content-end" aria-hidden="true">:</p>
        <p class="mb-0 para-2 col align-content-end text-capitalize">{{ formData.firstName }}</p>
      </div>
      <div class="d-flex  mb-2">
        <p class="mb-0 para-1 col align-content-end pl-0">Last Name</p>
        <p class="mb-0  align-content-end" aria-hidden="true">:</p>
        <p class="mb-0 para-2 col align-content-end text-capitalize">{{ formData.lastName }}</p>
      </div>
      <div class="d-flex  mb-2">
        <p class="mb-0 para-1 col align-content-end pl-0">Date of Birth</p>
        <p class="mb-0  align-content-end" aria-hidden="true">:</p>
        <p class="mb-0 para-2 col align-content-end text-capitalize">{{ formData.dob }}</p>
      </div>
      <div class="d-flex  mb-2">
        <p class="mb-0 para-1 col align-content-end pl-0" *ngIf="formData.ssn">Social Security Number</p>
        <p class="mb-0 para-1 col align-content-end pl-0" *ngIf="formData.itin">Individual Taxpayer Identification
          Number</p>
        <p class="mb-0  align-content-end" aria-hidden="true">:</p>
        <p class="mb-0 para-2 col align-content-end text-capitalize">
          {{ displayedSSN }}
          <button 
          type="button"
          class="ml-2 icon-btn pi new-blue btn p-0"
          [ngClass]="{ 'pi-eye': showSSN, 'pi-eye-slash': !showSSN }"
          (click)="toggleSSN()"
          (keydown.enter)="toggleSSN()"
          (keydown.space)="toggleSSN()"
          [attr.aria-label]="showSSN ? 'Hide Social Security Number' : 'Show Social Security Number'"
          [attr.aria-pressed]="showSSN"
          >
            <span class="sr-only">
              {{ showSSN ? 'Hide Social Security Number' : 'Show Social Security Number' }}
            </span>
            </button>

            <span class="sr-only" aria-live="polite" aria-atomic="true">
              {{ showSSN ? 'SSN IS VISIBLE' : 'SSN IS HIDDEN' }}
            </span>
        </p>
      </div>
      <div class="d-flex mb-2">
        <p class="mb-0 para-1 col pl-0 ">Email</p>
        <p class="mb-0 " aria-hidden="true">:</p>
        <p class="mb-0 para-2 col align-content-end text-break">{{ formData.email }}</p>
      </div>
      <div class="d-flex  mb-2">
        <p class="mb-0 para-1 col align-content-end pl-0">Phone</p>
        <p class="mb-0  align-content-end" aria-hidden="true">:</p>
        <p class="mb-0 para-2 col align-content-end">{{ formData.phoneNumber }}</p>
      </div>
    </div>

  </div>
  <div class="d-flex btn-container gap-3">
    <button type="button" class="btn btn-outline-secondary flex-fill" (click)="modalClose()">Return to Form</button>
    <button type="button" class="btn btn-primary flex-fill" (click)="submitDetails()" [disabled]="isLoading">
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>Confirm and Submit
    </button>
  </div>
</div>